module.exports = __webpack_public_path__ + "static/media/powerIcon.75195cc6.svg";